pageId = 'teams-progresses-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-dashboard').addClass 'active'
